import { render, staticRenderFns } from "./content4.vue?vue&type=template&id=4315a95a&"
import script from "./content4.vue?vue&type=script&lang=js&"
export * from "./content4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports